export const GET_LANGUAGES = `
  query GetLanguages {
    spracheinstellungen {
      translationSettings {
        languages {
          countryCode
          language
          flagIcons {
            sourceUrl(size: LARGE)
            title(format: RAW)
            altText
          }
        }
      }
    }
  }

`;

export const GET_STRINGS_LOGIN = `
  query GetLanguageStrings {
    spracheinstellungen {
      translationSettings {
        languages {
          countryCode
          translationStrings {
            login {
              stringMail
              stringHeadline
              stringNoAccount
              stringPassword
              stringPasswordForgot
              stringRegisterNow
              stringLogin
            }
          }
        }
      }
    }
  }
`;

export const GET_STRINGS_PASSWORD = `
  query GetLanguageStrings {
    spracheinstellungen {
      translationSettings {
        languages {
          countryCode
          translationStrings {
            password {
              stringError
              stringHeadline
              stringMail
              stringSuccess
              stringBackTitle
              stringBack
              stringButton
            }
          }
        }
      }
    }
  }
`;

export const GET_STRINGS_PASSWORD_NEW = `
  query GetLanguageStrings {
    spracheinstellungen {
      translationSettings {
        languages {
          countryCode
          translationStrings {
            passwordNew {
              stringBack
              stringBackTitle
              stringButton
              stringHeadline
              stringPassword
              stringPasswordRepeat
              stringError
              stringErrorPassword
              stringSuccess
            }
          }
        }
      }
    }
  }
`;

export const GET_STRINGS_REGISTER = `
  query GetLanguageStrings {
    spracheinstellungen {
      translationSettings {
        languages {
          countryCode
          translationStrings {
            register {
              stringCompany
              stringError
              stringHeadline
              stringLocation
              stringLocationPlaceholder
              stringMail
              stringName
              stringSuccessBack
              stringSuccessBody
              stringSuccessHeadline
              stringButton
              stringAccountRegisteredLink
              stringAccountRegistered
            }
          }
        }
      }
    }
  }
`;
